import * as React from 'react';

import {Icon} from '.';
import {IconProps} from './type';
import {Path} from 'react-native-svg';

const PickingIcon: React.FC<IconProps> = props => {
  return (
    <Icon viewBox="0 0 24 24" {...props} fill="none">
      <Path
        d="M21 20.25H6M6 20.25C6 20.695 5.86804 21.13 5.62081 21.5C5.37357 21.87 5.02217 22.1584 4.61104 22.3287C4.19991 22.499 3.74751 22.5436 3.31105 22.4568C2.87459 22.37 2.47368 22.1557 2.15901 21.841C1.84434 21.5263 1.63005 21.1254 1.54323 20.689C1.45642 20.2525 1.50097 19.8001 1.67127 19.389C1.84157 18.9778 2.12996 18.6264 2.49997 18.3792C2.86998 18.132 3.30499 18 3.75 18M6 20.25C6 19.6533 5.76295 19.081 5.34099 18.659C4.91903 18.2371 4.34674 18 3.75 18M3.75 18V3M6.75 5.25V9.75H15.75V5.25H6.75ZM6.75 12.75V17.25H18.75V12.75H6.75Z"
        stroke={props.fill}
        strokeWidth={1.5}
      />
    </Icon>
  );
};

export default PickingIcon;
